$('.JStoggle-btn').on('click', function(){
	$(this).closest('div').find('.JStoggle-content').toggleClass('d-none'); 
});

// RESPONSIVE NAVIGATON
$(".resp-nav-btn").on("click", function(){  
	$("#responsive-nav").toggleClass("openMe");	
	$('.overlay').show(); 
});

$(".JSclose-nav, .overlay").on("click", function(){  
	$("#responsive-nav").removeClass("openMe");	
	$('.overlay').hide();	 
});

// SCROLL TO TOP 
var $scrollTopBtn = $('.JSscroll-top');
var isScrollTopVisible = false;
var rafScheduled = false;

function applyScrollTopVisibility() {
	var scrollTop = window.scrollY || window.pageYOffset;
	var shouldShow = scrollTop > 150;

	if (shouldShow !== isScrollTopVisible) {
		isScrollTopVisible = shouldShow;
		$scrollTopBtn.toggleClass('JSvisible', shouldShow);
	}

	rafScheduled = false;
}

$(window).on('scroll', function () {
	if (!rafScheduled) {
		rafScheduled = true;
		requestAnimationFrame(applyScrollTopVisibility);
	}
});

applyScrollTopVisibility();

if ($scrollTopBtn.length) {
	$scrollTopBtn.on('click', function () {
		document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
	});
}